
<template>
    <div class="label-tree-wrapper">
        <el-tree
            ref="catalogTree"
            class="left-panel-tree"
            node-key="catId"
            highlight-current
            :data="treeList"
            :default-expand-all="true"
            :props="defaultProps"
            :expand-on-click-node="true"
            @node-click="handleNodeClick"
            empty-text="暂无子目录"
            :indent="0"
        >
            <span class="tree-node" slot-scope="{ node, data }">
                <div class="tree-node-label">
                    <i v-if="node.isLeaf" class="ecp-iconfont ecp-icon-single-folder"></i>
                    <i v-else class="ecp-iconfont ecp-icon-folder"></i>
                    <template>
                        <span class="tree-node-label-span" :title="node.label" >{{ node.label }}</span>
                    </template>
                </div>
                <el-popover trigger="click" placement="bottom-start" :popper-class="isDark?'knowledge-tooltip knowledge-tooltip-dark':'knowledge-tooltip'" class="more-operation">
                    <i slot="reference" class="ecp-iconfont ecp-icon-more"></i>
                    <div class="operation-button">
                        <div @click="handleUploadNode(node, data)">上传文件</div>
                        <div @click="handleAddNode(node, data)">新增子文件夹</div>
                        <div @click="handleEditNode(data, node)">编辑文件夹</div>
                        <div @click="handleRemoveNode(node, data)">删除文件夹</div>
                    </div>
                </el-popover>
            </span>
        </el-tree>
    </div>
</template>
<script>
export default {
    props: {
        treeList: {
            type: Array,
            default: () => []
        },
        currentTab: {
            type: String,
            default: null
        }
    },
    data () {
        return {
            file: null,
            LabelTypeName: '',
            defaultProps: {
                children: 'childrenCatalogList',
                label: 'catName'
            },
            breadList: [], // 面包屑数组
            breadLabel: '' // 面包屑文字
        };
    },
    computed: {
        isDark () {
            return this.$store.state.appSettings.isDark;
        }
    },
    watch: {
        currentTab (val) {
            if (val === '行业知识库') {
                this.$refs.catalogTree.setCurrentKey(2);
                let data = this.$refs.catalogTree.getCurrentNode();
                this.handleNodeClick(data);
            } else {
                this.$nextTick(function () {
                    this.$refs.catalogTree.setCurrentKey(null);
                });
            }
        }
    },
    methods: {
        // 文件夹树点击
        handleNodeClick (data, node) {
            if (!data) return;
            // 获取面包屑
            this.breadList = [];
            this.getTreeNode(this.$refs.catalogTree.getNode(data.catId));
            data = { breadLabel: this.breadLabel, ...data };
            this.$emit('clickTreeNode', data);
        },
        // 获取当前树节点和其父级节点
        getTreeNode (node) {
            if (node && node.label) {
                this.breadList.unshift(node.label);
                this.getTreeNode(node.parent); // 递归
                this.breadLabel = this.breadList.join(' > ');
            }
        },

        // 编辑文件夹
        handleEditNode (data, node) {
            this.$emit('handleEditNode', data);
        },
        // 添加子文件夹
        handleAddNode (node, data) {
            this.$emit('handleAddNode', data);
        },
        // 删除文件夹
        handleRemoveNode (node, data) {
            this.$emit('handleRemoveNode', data);
        },
        // 上传文件
        handleUploadNode (node, data) {
            this.$emit('handleUploadNode', data);
        }
    }
};
</script>
<style scoped lang="scss">
.label-tree-wrapper {
    .left-panel-tree {
        ::v-deep {
            background: var(--knowledge-left-bg);
            .el-tree-node__content {
                height: 32px;
                padding-right: 8px;
                background: var(--knowledge-left-bg);
                &:hover{
                    .tree-node{
                        background: var(--knowledge-bg-hover);
                        border-radius: 4px;
                    }
                }
            }
            .is-current > .el-tree-node__content .tree-node{
                background: var(--knowledge-bg-hover);
                border-radius: 4px;
            }
            .el-icon-caret-right:before{
                content: '';
                width:6px;
                height:6px;
                right: -4px;
                bottom: 3px;
                position: absolute;
                background: var(--knowledge-tree-arrow-close) no-repeat;
            }
            .el-tree-node__expand-icon.expanded{
                transform: rotate(0deg);
                &::before{
                background: var(--knowledge-tree-arrow-expend) no-repeat !important;
            }
            }
            .el-tree-node__expand-icon.is-leaf{
                &::before{
                    background: transparent;
                }
            }
        }

        .tree-node {
            display: flex;
            align-items: center;
            width: 100%;
            height: 100%;
            position: relative;
            margin-left: 4px;
            .tree-node-label{
                font-size: 14px;
                color: var(--knowledge-text);
                line-height: 20px;
                max-width: 150px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                i{
                    padding: 0 4px;
                    color: var(--knowledge-icon-color);
                }
            }
            .more-operation {
                display: none;
            }
            &:hover{
                .tree-node-label {
                    max-width: 120px;
                }
                .more-operation {
                    position: absolute;
                    right: 8px;
                    display: block;
                    color: var(--ai-model-classification-font);
                    font-size: 16px;
                }
            }
        }
    }
}
</style>

<style scoped lang="scss">
.left-panel-tree {
    // 装饰线样式
   ::v-deep{
        >.el-tree-node>.el-tree-node__content>.el-icon-caret-right:after {
            border-top: none;
        }

        >.el-tree-node::before {
            border-left: none !important;
        }

        .el-tree-node {
            position: relative;
            padding-left: 0px;
        }
        .el-tree-node__children {
            padding-left: 16px;
        }

        .el-tree-node :last-child:before {
            height: 32px;
        }

        .el-tree-node:before {
            content: '';
            left: 5px;
            position: absolute;
            right: auto;
            border-width: 1px;
            border-left: 1px solid var(--knowledge-tree-decoration-line);
            bottom: 0px;
            height: 100%;
            top: -17px;
            width: 1px;
        }

        .el-tree-node__expand-icon.is-leaf:after{
                content: '';
                left: 6px;
                position: absolute;
                right: auto;
                border-width: 1px;
                border-top: 1px solid var(--knowledge-tree-decoration-line);
                height: 20px;
                top: 4px;
                width: 10px;
        }
   }
}
</style>

<style lang="scss">
// 更多操作弹框样式
.knowledge-tooltip{
    padding: 0 16px;
    transform: translateY(-10px);
    width: 120px;
    min-width: 120px;
    background: rgba(255,255,255,0.85);
    box-shadow: 0px 2px 6px 0px rgba(7,22,51,0.2);
    border-radius: 4px;
    border: none;
    backdrop-filter: blur(10px);
    .popper__arrow{
        display: none;
    }
    .operation-button{
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        align-items:center;
        >div{
            cursor: pointer;
            width: 100%;
            height: 48px;
            line-height: 48px;
            text-align: center;
            font-size: 14px;
            color: rgba(7, 22, 51, 0.8500);
            border-bottom: 1px solid rgba(7,22,51,0.1);
            &:hover{
                color: rgba(18, 108, 255, 1);
            }
            &:last-child{
                border-bottom: 0px solid rgba(7,22,51,0.1);
            }
        }

    }
}
.knowledge-tooltip-dark{
    background: rgba(17, 19, 27, 0.85);
    .operation-button>div{
        color: rgba(255, 255, 255, 0.8500);
        border-bottom: 1px solid rgba(255,255,255,0.1);
        &:hover{
            color: rgba(47, 135, 255, 1);
        }
    }
}
</style>
